module.exports = __webpack_public_path__ + "static/img/4_1_1_1.6fca7ddf.jpg";